import type { RoomBookingRequest, RoomBookingResponse } from '../api/generated';
import { ROOM_BOOKING_TYPE } from '../components/RoomBookings/roomBookingConstants';
import { useBookings } from './useBookings';
import type { UseBookingsResult } from './useBookings';

export type UseRoomBookingsResult = UseBookingsResult<RoomBookingRequest, RoomBookingResponse>;

export function useRoomBookings(locationId: string | null): UseRoomBookingsResult {
  return useBookings<RoomBookingRequest, RoomBookingResponse>(ROOM_BOOKING_TYPE, locationId);
}
